import * as React from "react";

import { noop } from "../../../Common/TypingUtils";

import { LayoutEvents, LayoutEventsStatic } from "./Internals/LayoutEvents/LayoutEvents";

interface ExternalLayoutEventsMergerProps {
    externalLayoutEvents: LayoutEventsStatic | undefined;
    children: React.ReactNode;
}

export function ExternalLayoutEventsMerger(props: ExternalLayoutEventsMergerProps): JSX.Element {
    React.useEffect(() => {
        const externalLayoutEvents = props.externalLayoutEvents;
        if (externalLayoutEvents != undefined) {
            let allowEmit = true;
            const externalEmitterListener = LayoutEvents.addListener(() => {
                if (allowEmit) {
                    allowEmit = false;
                    externalLayoutEvents.emit();
                } else {
                    allowEmit = true;
                }
            });
            const internalEmitterListener = externalLayoutEvents.addListener(() => {
                if (allowEmit) {
                    allowEmit = false;
                    LayoutEvents.emit();
                    return;
                }
                allowEmit = true;
            });

            return () => {
                externalEmitterListener.remove();
                internalEmitterListener.remove();
            };
        }
        return noop;
    }, [props.externalLayoutEvents]);

    return <>{props.children}</>;
}
